// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a2aae80b","545":"8f1ac48e"}[chunkId] + ".chunk.js";
};